import { RuleEntity, ScoreEnum } from 'store/api/apiTypes';
import { useCachedRuleFactory } from './useCachedRuleFactory';
/** Wrapper around factory for content freshness rule with derived metrics. */
export const useCachedContentFreshnessRule = () => {
  const base = useCachedRuleFactory('getContentFreshnessRule');
  let successfulProductsCount = 0;
  const productMap = base.ruleData?.products as
    | Record<string, RuleEntity>
    | undefined;
  if (productMap) {
    Object.values(productMap).forEach(prod => {
      const score = prod?.assessment_score;
      if (score === ScoreEnum.HIGH) {
        successfulProductsCount += 1;
      }
    });
  }
  return {
    ...base,
    companyAssessment: base.company?.assessment_explanation || '',
    productKeys: base.ruleData ? Object.keys(base.ruleData.products || {}) : [],
    passed: successfulProductsCount,
  };
};
